/**
 * "A board was just added", for the Boards page, which lists from the Postgres
 * mirror and so sees a new board only once the mirror has it.
 *
 * Boards are added by the create dialog and from a template (RunnitsCRUDMixin),
 * which call `noteBoardsAdded`, and the page answers with one catch-up refetch a
 * mirror lag later: at once if it is open, and on arrival if it opens before the
 * lag has passed (create a board, open it, come straight back). Nothing else
 * refetches it: an edit (its settings, its access) leaves the board where it is
 * in the list until Refresh, and a deleted board is dimmed by its own binding,
 * whose row then asks for the list again by itself.
 */
import moment from 'moment-timezone';
import { MirrorLagChannel, createMirrorLagChannel } from '@/utils/mirrorLagChannel';

type BoardsAddedListener = () => void;

export const BOARDS_ADDED: MirrorLagChannel = createMirrorLagChannel();

/** A board was created. */
export function noteBoardsAdded(now: moment.Moment = moment()): void {
	BOARDS_ADDED.noteChanged(now);
}

/** How long until the mirror has the newest board: 0 once it has. */
export function boardsAddedRemainingMs(now: moment.Moment = moment()): number {
	return BOARDS_ADDED.remainingMs(now);
}

/** Call `listener` on every new board from now on. Returns the unsubscribe. */
export function onBoardsAdded(listener: BoardsAddedListener): () => void {
	return BOARDS_ADDED.onChanged(listener);
}

/** For specs: forget every new board and every listener. */
export function resetBoardsAdded(): void {
	BOARDS_ADDED.reset();
}
